import { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Formik, Form } from 'formik';
import { Container, Typography, Stack, Box, Button, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { axiosPrivate } from '../../../common/axiosPrivate';
import NotificationContext from '../../../context/notificationContext';
import AuthContext from '../../../context/authContext';

import KepegawaianForm from '../../../sections/@dashboard/pegawai/forms/KepegawaianForm';
import pegawaiFormModel from '../../../sections/@dashboard/pegawai/form-model/pegawaiFormModel';
import validationSchema from '../../../sections/@dashboard/pegawai/form-model/validationSchema';

const KepegawaianPegawaiPage = ({id, handleCloseModal, handleUpdateTable}) => {
  const notificationCtx = useContext(NotificationContext);
  const { user } = useContext(AuthContext);
  const [dropDown, setDropDown] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const { formId, formField } = pegawaiFormModel;
  const [initialValues, setInitialValues] = useState({});

  const _handleSubmit = async (values, actions) => {
    const {
      tglMasuk,
      tglKeluar,
      kantor,
      jabatan,
      integritas,
      statusPegawai,
      tglStatus,
      tglMulaiKontrak,
      tglAkhirKontrak,
      kontrakMagangKe,
      kontrakPkwtKe,
      notes
    } = values;
  
    const params = {
      tglMasuk: moment(tglMasuk).format('YYYY-MM-DD'),
      kantor,
      jabatan,
      integritas,
      statusPegawai,
      tglStatus,
      tglMulaiKontrak,
      tglAkhirKontrak,
      kontrakMagangKe,
      kontrakPkwtKe,
      notes,
      dibuatOleh: user?._id,
      tglUbah: moment().format('YYYY-MM-DDTHH:mm:ss'),
    };
  
    // Check if tglKeluar exists and is not an empty string, then add it to params
    if (tglKeluar) {
      params.tglKeluar = moment(tglKeluar).format('YYYY-MM-DD');
    }

    // console.log(JSON.stringify(params));
  
    try {
      const response = await axiosPrivate.put(`/pegawai/update-partial/${id}`, params);
      const { result } = response?.data;

      handleUpdateTable(result);
      handleMessage(response?.data);
    } catch (error) {
      console.error(error);
      handleMessage(error);
    } finally {
      actions.setSubmitting(false);
    }
  };
  

  const handleMessage = (params) => {
    if(params?.success) {
      notificationCtx.setup({
        severity: 'success',
        title: 'Success',
        message: 'Data Berhasil Diubah.'
      });
    } else {
      notificationCtx.setup({
        severity: 'error',
        title: 'Error',
        message: params?.response
      })
    }
  }

  useEffect(() => {
    setPageLoading(true);
    const getDropdown = async () => {
      await axiosPrivate.get('pegawai/dropdown/list')
      .then((response) => {
        const data = response?.data;
        
        setDropDown(data);
      })
      .catch((error) => console.log(error));
    }

    getDropdown()
    .finally(() => {
      axiosPrivate.get(`/pegawai/${id}`)
      .then((response) => {
        const data = response?.data;

        setInitialValues({
          tglMasuk: moment(data?.tglMasuk).format('YYYY-MM-DD'),
          tglKeluar: data?.tglKeluar ? moment(data?.tglKeluar).format('YYYY-MM-DD') : '',
          kantor: data?.kantor,
          jabatan: data?.jabatan,
          integritas: data?.integritas,
          statusPegawai: data?.statusPegawai,
          tglStatus: data?.tglStatus,
          tglMulaiKontrak: data?.tglMulaiKontrak,
          tglAkhirKontrak: data?.tglAkhirKontrak,
          kontrakMagangKe: data?.kontrakMagangKe,
          kontrakPkwtKe: data?.kontrakPkwtKe,
          notes: data?.notes
        });
      })
      .catch((error) => console.log(error?.response))
      .finally(() => setPageLoading(false));
    });
  }, [id]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Ubah Kepegawaian
            </Typography>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema[2]}
            onSubmit={_handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form id={formId}>
                <KepegawaianForm formField={formField} dropDown={dropDown} statusPegawai={initialValues.statusPegawai} />
                <Stack
                  direction="row"
                  justifyContent="end"
                  mt={2}
                  spacing={1}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseModal}
                  >
                    Kembali
                  </Button>
                  <LoadingButton
                    type="submit"
                    loading={isSubmitting}
                    variant="contained"
                  >
                    Simpan
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
        </Container>
        )}
    </>
  );
};
  
export default KepegawaianPegawaiPage;
